// src/pages/CartPage.jsx - MOBİL UYUMLU VERSİYON
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  ArrowLeft, Minus, Plus, Trash2, ShoppingBag,
  CreditCard, Truck, Shield, Tag, ChevronRight, Check,
  Zap, Info, AlertCircle, Heart
} from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import { useSearch } from '../context/SearchContext';
import { openCartSidebar } from '../components/CartSidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getAllCampaigns, getFreeShippingCampaign } from '../services/discountService';
import { getAllProducts } from '../services/productService';
import toast from 'react-hot-toast';

export default function CartPage() {
  const navigate = useNavigate();
  const { items, cartCount, updateQuantity, removeFromCart, clearCart } = useCart();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [availableCategories, setAvailableCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [freeShippingCampaign, setFreeShippingCampaign] = useState(null);

  const { wishlistCount } = useWishlist();
  const { searchQuery, setSearchQuery } = useSearch();

  // src/pages/CartPage.jsx - TAM ÇÖZÜM

// src/pages/CartPage.jsx

// src/pages/CartPage.jsx

useEffect(() => {
  const fetchOffers = async () => {
    try {
      console.log('🚀 Kampanyalar yükleniyor...');
      
      const [campaignsResult, productsResult, freeShippingResult] = await Promise.all([
        getAllCampaigns(),
        getAllProducts(),
        getFreeShippingCampaign()
      ]);

      console.log('📥 Kampanyalar API yanıtı:', campaignsResult);

      if (campaignsResult.success) {
        console.log('✅ Tüm kampanyalar:', campaignsResult.campaigns.length);
        
        // ✅ ÜCRETSİZ KARGO OLMAYAN TÜM KAMPANYALARI AL
        const discountCampaigns = campaignsResult.campaigns.filter(campaign => {
          // Eğer freeShippingThreshold varsa, bu ücretsiz kargo kampanyası
          const isFreeShipping = campaign.freeShippingThreshold && campaign.freeShippingThreshold > 0;
          
          // Ücretsiz kargo kampanyalarını hariç tut
          const isDiscount = !isFreeShipping;
          
          console.log(`  - ${campaign.title}:`);
          console.log(`    type=${campaign.campaignType}`);
          console.log(`    freeShippingThreshold=${campaign.freeShippingThreshold}`);
          console.log(`    isFreeShipping=${isFreeShipping}`);
          console.log(`    isDiscount=${isDiscount}`);
          
          return isDiscount;
        });
        
        console.log('🎯 İndirim kampanyaları:', discountCampaigns.length);
        discountCampaigns.forEach(c => {
          console.log(`  ✅ ${c.title}:`);
          console.log(`     - Type: ${c.campaignType}`);
          console.log(`     - Category: ${c.targetCategory}`);
          console.log(`     - Discount: %${c.discountPercent}`);
          console.log(`     - End Date: ${c.endDate}`);
        });
        
        // ✅ STATE'E KAYDET
        setCampaigns(discountCampaigns);
        console.log('💾 State güncellendi:', discountCampaigns.length, 'kampanya');
      }

      if (freeShippingResult.success && freeShippingResult.campaign) {
        console.log('🚚 Ücretsiz kargo kampanyası yüklendi:', freeShippingResult.campaign.title);
        setFreeShippingCampaign(freeShippingResult.campaign);
      }

      if (productsResult.success) {
        const activeProducts = productsResult.products.filter(product =>
          product.isActive !== false
        );
        setProducts(activeProducts);

        const categoriesSet = new Set();
        activeProducts.forEach(product => {
          if (product.category) {
            const mainCat = product.category.includes(' > ')
              ? product.category.split(' > ')[0]
              : product.category;
            categoriesSet.add(mainCat);
          }
        });
        setAvailableCategories(Array.from(categoriesSet));
        console.log('📂 Kategoriler yüklendi:', Array.from(categoriesSet));
      }
    } catch (error) {
      console.error('❌ Kampanyalar yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };
  
  fetchOffers();
}, []);

useEffect(() => {
  console.log('🔄 Campaigns state güncellendi:', campaigns.length);
  campaigns.forEach(c => console.log(`  - ${c.title}`));
}, [campaigns]);

  // ✅ ÜCRETSIZ KARGO LİMİTİ
  const FREE_SHIPPING_THRESHOLD = freeShippingCampaign?.freeShippingThreshold || 0;
  const hasFreeShippingCampaign = freeShippingCampaign && FREE_SHIPPING_THRESHOLD > 0;

  // Ham sepet toplamı (ürün fiyatları × adet)
  const rawCartTotal = items.reduce((sum, item) => {
    const itemPrice = item.currentPrice || item.price;
    return sum + (itemPrice * item.quantity);
  }, 0);

  // getCampaignsWithEligibleProducts fonksiyonunu BUL ve DEĞİŞTİR:
// src/pages/CartPage.jsx - KATEGORİ EŞLEŞTİRME DÜZELTMESİ

// src/pages/CartPage.jsx - DEBUG LOGLAMA

// src/pages/CartPage.jsx - TAM DEBUG VERSİYONU

// src/pages/CartPage.jsx - getCampaignsWithEligibleProducts fonksiyonunu değiştir

const getCampaignsWithEligibleProducts = () => {
  console.log('\n🔍 ===== getCampaignsWithEligibleProducts BAŞLADI =====');
  console.log('📦 Sepetteki ürün sayısı:', items.length);
  console.log('🎯 Yüklenen kampanya sayısı:', campaigns.length);
  
  const result = campaigns.filter(campaign => {
    console.log(`\n🔍 Kampanya İnceleniyor: "${campaign.title}"`);
    
    // ✅ 1. Ücretsiz kargo kampanyalarını atla
    if (campaign.discountType === 'free_shipping' || 
        (campaign.freeShippingThreshold && campaign.freeShippingThreshold > 0)) {
      console.log(`  ⏭️ Ücretsiz kargo kampanyası, atlandı`);
      return false;
    }

    // ✅ 2. Tarih kontrolü - null ise süresiz kabul et
    if (campaign.endDate) {
      const endDate = new Date(campaign.endDate);
      const now = new Date();
      const isActive = endDate > now;
      console.log(`  📅 Bitiş: ${campaign.endDate}`);
      console.log(`  📅 Şimdi: ${now.toISOString()}`);
      console.log(`  ${isActive ? '✅' : '❌'} Aktif mi? ${isActive}`);
      
      if (!isActive) {
        console.log(`  ❌ Kampanya süresi dolmuş, elendi`);
        return false;
      }
    } else {
      console.log(`  ♾️ Süresiz kampanya`);
    }

    // ✅ 3. Kampanya tipi kontrolü
    console.log(`  🏷️ Kampanya Tipi: "${campaign.campaignType}"`);
    
    // ✅ 4. Ürün uygunluğu
    console.log(`  🔎 Ürün uygunluğu kontrol ediliyor...`);
    
    const hasEligibleItems = items.some(item => {
      console.log(`\n    🔍 Ürün kontrol: "${item.name}"`);
      console.log(`       Ürün kategorisi: "${item.category}"`);
      
      // ✅ Genel kampanya - Tüm ürünler
      if (campaign.campaignType === 'general' || !campaign.targetCategory) {
        console.log(`       🌍 Genel kampanya - tüm ürünler uygun`);
        return true;
      }
      
      // ✅ Kategori kampanyası
      if (campaign.campaignType === 'category' && campaign.targetCategory) {
        console.log(`       🎯 Hedef kategori: "${campaign.targetCategory}"`);
        
        // Normalize et - büyük/küçük harf duyarsız
        const itemCategory = item.category?.trim().toLowerCase() || '';
        const targetCategory = campaign.targetCategory?.trim().toLowerCase() || '';
        
        console.log(`       Normalize item: "${itemCategory}"`);
        console.log(`       Normalize target: "${targetCategory}"`);
        
        // Tam eşleşme veya ana kategori eşleşmesi
        if (itemCategory === targetCategory) {
          console.log(`       ✅ Tam eşleşme!`);
          return true;
        }
        
        // Alt kategori kontrolü (örn: "Gıda & İçecek > Şekerleme")
        if (itemCategory.includes(targetCategory) || targetCategory.includes(itemCategory)) {
          console.log(`       ✅ Alt kategori eşleşmesi!`);
          return true;
        }
        
        // Ana kategori karşılaştırması
        const itemMainCat = itemCategory.includes('>') 
          ? itemCategory.split('>')[0].trim() 
          : itemCategory;
        const targetMainCat = targetCategory.includes('>') 
          ? targetCategory.split('>')[0].trim() 
          : targetCategory;
        
        console.log(`       Ana kategori item: "${itemMainCat}"`);
        console.log(`       Ana kategori target: "${targetMainCat}"`);
        
        if (itemMainCat === targetMainCat) {
          console.log(`       ✅ Ana kategori eşleşmesi!`);
          return true;
        }
        
        console.log(`       ❌ Kategori eşleşmedi`);
        return false;
      }
      
      // ✅ Ürün ID kampanyası
      if (campaign.campaignType === 'product' && campaign.targetId) {
        console.log(`       🎯 Hedef ürün ID: "${campaign.targetId}"`);
        const matches = item.id === campaign.targetId;
        console.log(`       ${matches ? '✅' : '❌'} Ürün ID eşleşmesi: ${matches}`);
        return matches;
      }
      
      console.log(`       ❓ Belirsiz durum`);
      return false;
    });

    console.log(`  📊 "${campaign.title}" için uygun ürün var mı? ${hasEligibleItems}`);
    return hasEligibleItems;
  });

  console.log(`\n✅ Uygun kampanya sayısı: ${result.length}`);
  result.forEach(c => console.log(`   - ${c.title} (${c.discountPercent}%)`));
  console.log('===== getCampaignsWithEligibleProducts BİTTİ =====\n');
  
  return result;
};

// getEligibleItemsTotal fonksiyonunu da güncelle
const getEligibleItemsTotal = (campaign) => {
  console.log(`\n💰 getEligibleItemsTotal - Kampanya: "${campaign.title}"`);
  
  let total = 0;
  
  items.forEach(item => {
    let isEligible = false;

    // ✅ Genel kampanya
    if (campaign.campaignType === 'general' || !campaign.targetCategory) {
      isEligible = true;
      console.log(`  📦 ${item.name}: Genel kampanya → uygun`);
    }
    // ✅ Kategori kampanyası
    else if (campaign.campaignType === 'category' && campaign.targetCategory) {
      const itemCategory = item.category?.trim().toLowerCase() || '';
      const targetCategory = campaign.targetCategory?.trim().toLowerCase() || '';
      
      // Tam eşleşme
      if (itemCategory === targetCategory) {
        isEligible = true;
      }
      // Alt kategori
      else if (itemCategory.includes(targetCategory) || targetCategory.includes(itemCategory)) {
        isEligible = true;
      }
      // Ana kategori
      else {
        const itemMainCat = itemCategory.includes('>') 
          ? itemCategory.split('>')[0].trim() 
          : itemCategory;
        const targetMainCat = targetCategory.includes('>') 
          ? targetCategory.split('>')[0].trim() 
          : targetCategory;
        
        if (itemMainCat === targetMainCat) {
          isEligible = true;
        }
      }
      
      console.log(`  📦 ${item.name}:`);
      console.log(`     Kategori: ${item.category}`);
      console.log(`     Hedef: ${campaign.targetCategory}`);
      console.log(`     Uygun: ${isEligible}`);
    }
    // ✅ Ürün kampanyası
    else if (campaign.campaignType === 'product' && campaign.targetId) {
      isEligible = item.id === campaign.targetId;
      console.log(`  📦 ${item.name}: Ürün ID kontrolü → ${isEligible}`);
    }

    if (isEligible) {
      const itemPrice = item.currentPrice || item.price;
      const itemTotal = itemPrice * item.quantity;
      total += itemTotal;
      console.log(`     Fiyat: ${itemPrice}₺ x ${item.quantity} = ${itemTotal}₺`);
    }
  });
  
  console.log(`  💵 Toplam uygun ürün tutarı: ${total.toFixed(2)}₺`);
  return total;
};

const getApplicableCampaigns = () => {
  console.log('\n🎯 ===== getApplicableCampaigns =====');
  const eligibleCampaigns = getCampaignsWithEligibleProducts();
  
  const applicable = eligibleCampaigns.filter(campaign => {
    console.log(`\n💳 Kampanya: "${campaign.title}"`);
    console.log(`   Min alışveriş: ${campaign.minPurchase}₺`);
    
    if (campaign.minPurchase) {
      const eligibleTotal = getEligibleItemsTotal(campaign);
      const passes = eligibleTotal >= campaign.minPurchase;
      console.log(`   Sepet tutarı: ${eligibleTotal.toFixed(2)}₺`);
      console.log(`   ${passes ? '✅' : '❌'} Limit ${passes ? 'aşıldı' : 'aşılamadı'}`);
      return passes;
    }
    
    console.log(`   ✅ Min limit yok, geçerli`);
    return true;
  });
  
  console.log(`\n✅ Uygulanabilir kampanya sayısı: ${applicable.length}`);
  applicable.forEach(c => console.log(`   - ${c.title} (${c.discountPercent}%)`));
  console.log('===== getApplicableCampaigns BİTTİ =====\n');
  
  return applicable;
};

  // Yakın kampanyalar
  const getNearMissCampaigns = () => {
    return getCampaignsWithEligibleProducts().filter(campaign => {
      if (campaign.minPurchase) {
        const eligibleTotal = getEligibleItemsTotal(campaign);
        if (eligibleTotal < campaign.minPurchase) {
          const remaining = campaign.minPurchase - eligibleTotal;
          return remaining <= 100;
        }
      }
      return false;
    });
  };

  const applicableCampaigns = getApplicableCampaigns();
  const nearMissCampaigns = getNearMissCampaigns();

  const bestCampaign = applicableCampaigns.length > 0
    ? applicableCampaigns.reduce((max, campaign) =>
      campaign.discountPercent > (max?.discountPercent || 0) ? campaign : max
    )
    : null;

  const calculateCampaignDiscount = () => {
  console.log('\n💸 ===== calculateCampaignDiscount =====');
  
  if (!bestCampaign) {
    console.log('❌ En iyi kampanya yok, indirim 0');
    return 0;
  }

  console.log(`🏆 En iyi kampanya: "${bestCampaign.title}"`);
  console.log(`   İndirim oranı: %${bestCampaign.discountPercent}`);
  
  const eligibleItemsTotal = getEligibleItemsTotal(bestCampaign);
  const discount = eligibleItemsTotal * (bestCampaign.discountPercent / 100);
  
  console.log(`   Uygun ürün toplamı: ${eligibleItemsTotal.toFixed(2)}₺`);
  console.log(`   İndirim tutarı: ${discount.toFixed(2)}₺`);
  console.log('===== calculateCampaignDiscount BİTTİ =====\n');
  
  return discount;
};

  const campaignDiscount = calculateCampaignDiscount();
  const totalDiscount = campaignDiscount;

  // İndirimleri düştükten SONRA ara toplam
  const cartTotalAfterDiscounts = rawCartTotal - totalDiscount;

  // Bu fonksiyonu bul ve değiştir:
  const calculateShippingCost = () => {
    if (hasFreeShippingCampaign && cartTotalAfterDiscounts >= FREE_SHIPPING_THRESHOLD) {
      return 0;
    }

    const totalShipping = items.reduce((sum, item) => {
      const itemShippingFee = Number(item.shippingFee) || 0;
      return sum + (itemShippingFee * item.quantity);
    }, 0);

    return totalShipping;
  };

  const shippingCost = calculateShippingCost();

  // Ücretsiz kargo için kalan tutar
  const remainingForFreeShipping = Math.max(0, FREE_SHIPPING_THRESHOLD - cartTotalAfterDiscounts);

  // FINAL TOPLAM
  const finalTotal = cartTotalAfterDiscounts + shippingCost;

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleCheckout = () => {
    return navigate('/checkout');
  };

  console.log(`\n💵 ===== FİNAL HESAPLAMA =====`);
  console.log(`Ham Toplam: ${rawCartTotal.toFixed(2)}₺`);
  console.log(`Kampanya İndirimi: -${campaignDiscount.toFixed(2)}₺`);
  console.log(`Toplam İndirim: -${totalDiscount.toFixed(2)}₺`);
  console.log(`İndirimli Ara Toplam: ${cartTotalAfterDiscounts.toFixed(2)}₺`);
  console.log(`Kargo (Ürün Bazlı): +${shippingCost.toFixed(2)}₺`);
  console.log(`ÖDENECEK TOPLAM: ${finalTotal.toFixed(2)}₺`);
  console.log(`Ücretsiz Kargo İçin Kalan: ${remainingForFreeShipping.toFixed(2)}₺`);
  console.log(`==============================\n`);

  if (items.length === 0) {
    return (
      <div className="cart-page">
        <Style />

        <Header
          wishlistCount={wishlistCount}
          cartCount={cartCount}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onSearch={handleSearch}
          onCartClick={openCartSidebar}
          onWishlistClick={() => navigate('/wishlist')}
          onCampaignsClick={() => navigate('/campaigns')}
          availableCategories={availableCategories}
          products={products}
        />

        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Anasayfa</Link>
            <ChevronRight size={16} />
            <span>Sepetim</span>
          </div>

          <div className="empty-cart-section">
            <div className="empty-cart-content">
              <div className="empty-icon-wrapper">
                <div className="empty-icon-bg"></div>
                <ShoppingBag size={64} strokeWidth={1.5} />
              </div>
              <h1>Sepetiniz Boş</h1>
              <p>Henüz sepetinize ürün eklemediniz. İlginizi çekebilecek harika ürünlerimize göz atın!</p>

              <div className="empty-actions">
                <Link to="/" className="primary-btn-link">
                  <button className="primary-btn">
                    <ShoppingBag size={18} />
                    Alışverişe Başla
                  </button>
                </Link>
                <Link to="/wishlist" className="secondary-btn-link">
                  <button className="secondary-btn">
                    <Heart size={18} />
                    Favorilerime Git
                  </button>
                </Link>
              </div>

              <div className="empty-features">
                {/* ✅ Sadece kampanya varsa göster */}
                {hasFreeShippingCampaign && (
                  <div className="feature-item">
                    <div className="feature-icon">
                      <Truck size={20} />
                    </div>
                    <div className="feature-text">
                      <h4>Ücretsiz Kargo</h4>
                      <p>{FREE_SHIPPING_THRESHOLD}₺ üzeri</p>
                    </div>
                  </div>
                )}
                <div className="feature-item">
                  <div className="feature-icon">
                    <Shield size={20} />
                  </div>
                  <div className="feature-text">
                    <h4>Güvenli Ödeme</h4>
                    <p>256-bit SSL</p>
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-icon">
                    <Tag size={20} />
                  </div>
                  <div className="feature-text">
                    <h4>Özel Kampanyalar</h4>
                    <p>Fırsatları kaçırma</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Style />

      <Header
        wishlistCount={wishlistCount}
        cartCount={cartCount}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onSearch={handleSearch}
        onCartClick={openCartSidebar}
        onWishlistClick={() => navigate('/wishlist')}
        onCampaignsClick={() => navigate('/campaigns')}
        availableCategories={availableCategories}
        products={products}
      />

      <div className="container">
        <div className="breadcrumb">
          <Link to="/">Anasayfa</Link>
          <ChevronRight size={16} />
          <span>Sepetim</span>
        </div>

        <div className="cart-layout">
          <div className="cart-items-section">
            <div className="section-header">
              <h1>Sepetim ({cartCount} Ürün)</h1>
              <button
                className="clear-btn"
                onClick={() => {
                  if (window.confirm('Sepeti temizlemek istediğinize emin misiniz?')) {
                    clearCart();
                    toast.success('Sepet temizlendi');
                  }
                }}
              >
                <Trash2 size={16} />
                <span>Sepeti Temizle</span>
              </button>
            </div>

            {/* ✅ ÜCRETSİZ KARGO BARI - Sadece kampanya varsa göster */}
            {hasFreeShippingCampaign && remainingForFreeShipping > 0 && (
              <div className="free-shipping-notice">
                <Truck size={20} />
                <div className="notice-content">
                  <p>
                    <strong>{freeShippingCampaign.title || 'Ücretsiz Kargo'}</strong> için{' '}
                    <strong>{remainingForFreeShipping.toFixed(2)}₺</strong> daha ekleyin!
                  </p>
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: `${Math.min(100, (cartTotalAfterDiscounts / FREE_SHIPPING_THRESHOLD) * 100)}%` }}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Ücretsiz kargo kazanıldı - Sadece kampanya varsa göster */}
            {hasFreeShippingCampaign && remainingForFreeShipping === 0 && (
              <div className="free-shipping-achieved">
                <Truck size={20} />
                <div className="notice-content">
                  <p>🎉 <strong>{freeShippingCampaign.title || 'Ücretsiz kargo'} kazandınız!</strong></p>
                </div>
              </div>
            )}

            {/* Uygulanan Kampanyalar */}
            {applicableCampaigns.length > 0 && (
              <div className="applied-offers-section">
                <h3>
                  <Check size={20} />
                  Uygulanan Kampanyalar
                </h3>

                {applicableCampaigns.map(campaign => (
                  <div key={campaign.id} className="applied-offer campaign-applied">
                    <div className="offer-icon campaign-icon">
                      <Zap size={18} />
                    </div>
                    <div className="offer-info">
                      <div className="offer-title">
                        <span className="offer-badge campaign">KAMPANYA</span>
                        <span className="offer-name">{campaign.title}</span>
                      </div>
                      <p className="offer-desc">{campaign.description}</p>
                      {campaign === bestCampaign && (
                        <div className="offer-discount">
                          <Tag size={14} />
                          <span>-{campaignDiscount.toFixed(2)}₺ indirim</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Yakın Kampanyalar */}
            {nearMissCampaigns.length > 0 && (
              <div className="near-miss-offers-section">
                <h3>
                  <AlertCircle size={20} />
                  Yakın Olduğunuz Kampanyalar
                </h3>

                {nearMissCampaigns.map(campaign => {
                  const eligibleTotal = getEligibleItemsTotal(campaign);
                  const remaining = campaign.minPurchase - eligibleTotal;
                  return (
                    <div key={campaign.id} className="near-miss-offer campaign-near">
                      <div className="offer-icon campaign-icon-near">
                        <Zap size={18} />
                      </div>
                      <div className="offer-info">
                        <div className="offer-title">
                          <span className="offer-badge campaign">KAMPANYA</span>
                          <span className="offer-name">{campaign.title}</span>
                        </div>
                        <p className="offer-desc">{campaign.description}</p>
                        <div className="offer-warning">
                          <Info size={14} />
                          <span>
                            {campaign.targetCategory && (
                              <>{campaign.targetCategory} kategorisinden </>
                            )}
                            <strong>{remaining.toFixed(2)}₺</strong> daha ekleyin!
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="cart-items-list">
              {items.map(item => {
                const itemPrice = item.currentPrice || item.price;
                const itemOriginalPrice = item.originalPrice || item.price;
                const hasItemDiscount = itemOriginalPrice > itemPrice;
                const itemShippingFee = Number(item.shippingFee) || 0;

                return (
                  <div key={item.id} className="cart-item">
                    <Link to={`/product/${item.id}`} className="item-image">
                      <img src={item.image} alt={item.name} />
                    </Link>

                    <div className="item-details">
                      <Link to={`/product/${item.id}`}>
                        <h3>{item.name}</h3>
                      </Link>
                      <p className="item-desc">{item.description}</p>

                      {/* Ürün indirimi */}
                      {hasItemDiscount && (
                        <span className="discount-tag">
                          %{Math.round(((itemOriginalPrice - itemPrice) / itemOriginalPrice) * 100)} İndirim
                        </span>
                      )}

                      {/* ✅ ÜRÜN KARGO ÜCRETİ BİLGİSİ - Her zaman göster, kampanya yoksa veya kazanılmışsa gizle */}
                      {itemShippingFee > 0 && (!hasFreeShippingCampaign || remainingForFreeShipping > 0) && (
                        <div className="item-shipping-info">
                          <Truck size={12} />
                          <span>Kargo: {itemShippingFee.toFixed(2)}₺ × {item.quantity}</span>
                        </div>
                      )}
                    </div>

                    <div className="item-actions">
                      <div className="quantity-controls">
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity - 1)}
                          disabled={item.quantity <= 1}
                          aria-label="Azalt"
                        >
                          <Minus size={16} />
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                          aria-label="Artır"
                        >
                          <Plus size={16} />
                        </button>
                      </div>

                      <div className="item-price">
                        {hasItemDiscount && (
                          <span className="original-price">
                            {(itemOriginalPrice * item.quantity).toFixed(2)}₺
                          </span>
                        )}
                        <span className="current-price">{(itemPrice * item.quantity).toFixed(2)}₺</span>
                      </div>

                      <button
                        className="remove-btn"
                        onClick={() => {
                          removeFromCart(item.id);
                          toast.success('Ürün sepetten kaldırıldı');
                        }}
                        aria-label="Sepetten kaldır"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="order-summary">
            <h2>Sipariş Özeti</h2>

            <div className="summary-details">
              <div className="summary-row">
                <span>Ara Toplam</span>
                <span>{rawCartTotal.toFixed(2)}₺</span>
              </div>

              {campaignDiscount > 0 && (
                <div className="summary-row discount campaign">
                  <span>
                    <Tag size={14} />
                    Kampanya İndirimi
                  </span>
                  <span>-{campaignDiscount.toFixed(2)}₺</span>
                </div>
              )}

              {totalDiscount > 0 && (
                <div className="summary-row total-savings">
                  <span>💰 Toplam Tasarruf</span>
                  <span>{totalDiscount.toFixed(2)}₺</span>
                </div>
              )}

              {/* ✅ KARGO ÜCRETİ SATIRI - Her zaman göster */}
              <div className="summary-row shipping">
                <span>
                  <Truck size={14} />
                  Kargo
                </span>
                <span className={hasFreeShippingCampaign && remainingForFreeShipping === 0 ? 'free' : ''}>
                  {hasFreeShippingCampaign && remainingForFreeShipping === 0 ? 'Ücretsiz' : `${shippingCost.toFixed(2)}₺`}
                </span>
              </div>

              <div className="summary-row total">
                <span>Toplam</span>
                <span>{finalTotal.toFixed(2)}₺</span>
              </div>
            </div>

            {totalDiscount > 0 && (
              <div className="savings-badge">
                <Check size={16} />
                <span>{totalDiscount.toFixed(2)}₺ tasarruf ettiniz!</span>
              </div>
            )}

            {hasFreeShippingCampaign && remainingForFreeShipping === 0 && (
              <div className="free-shipping-badge">
                <Truck size={16} />
                <span>{freeShippingCampaign.title || 'Ücretsiz kargo'} kazandınız! 🎉</span>
              </div>
            )}

            <button className="checkout-btn" onClick={handleCheckout}>
              <CreditCard size={20} />
              Siparişi Tamamla
            </button>

            <div className="security-info">
              <Shield size={16} />
              <span>256-bit SSL ile güvenli ödeme</span>
            </div>

            <div className="payment-methods">
              <p>Kabul Edilen Ödeme Yöntemleri</p>
              <div className="methods">
                <span>💳 Kredi Kartı</span>
                <span>🏦 Banka Kartı</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

function Style() {
  return <style>{`
    * { 
      margin: 0; 
      padding: 0; 
      box-sizing: border-box; 
      -webkit-tap-highlight-color: transparent;
    }

    .cart-page {
      min-height: 100vh;
      background: #f8f9fa;
      display: flex;
      flex-direction: column;
    }
    
    .container {
      max-width: 1320px;
      margin: 0 auto;
      padding: 0 20px;
      flex: 1;
    }
    
    a {
      text-decoration: none;
      color: inherit;
    }
    
    .empty-cart-section {
      min-height: 600px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
    }
    
    .empty-cart-content {
      text-align: center;
      padding: 60px 40px;
      background: #fff;
      border-radius: 24px;
      max-width: 700px;
      width: 100%;
      box-shadow: 0 4px 24px rgba(0,0,0,0.06);
    }
    
    .empty-icon-wrapper {
      position: relative;
      width: 120px;
      height: 120px;
      margin: 0 auto 32px;
    }
    
    .empty-icon-bg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 120px;
      height: 120px;
      background: linear-gradient(135deg, #fff5f5, #ffe8e8);
      border-radius: 50%;
      animation: pulse-bg 3s ease-in-out infinite;
    }
    
    @keyframes pulse-bg {
      0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.8; }
      50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.5; }
    }
    
    .empty-icon-wrapper svg {
      position: relative;
      z-index: 1;
      color: #E5332A;
      margin-top: 28px;
    }
    
    .empty-cart-content h1 { 
      font-size: 32px; 
      margin-bottom: 16px;
      color: #2B2B2B;
      font-weight: 700;
    }
    
    .empty-cart-content > p { 
      color: #868e96; 
      font-size: 16px;
      line-height: 1.6;
      margin-bottom: 32px;
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }
    
    .empty-actions {
      display: flex;
      gap: 12px;
      justify-content: center;
      margin-bottom: 48px;
      flex-wrap: wrap;
    }
    
    .primary-btn-link, .secondary-btn-link {
      display: inline-block;
    }
    
    .primary-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #E5332A;
      color: #fff;
      border: none;
      padding: 14px 28px;
      border-radius: 12px;
      font-weight: 600;
      font-size: 15px;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.2);
    }
    
    .primary-btn:hover {
      background: #c72a22;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(229, 51, 42, 0.3);
    }
    
    .primary-btn:active {
      transform: translateY(0);
    }
    
    .secondary-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #fff;
      color: #2B2B2B;
      border: 2px solid #e9ecef;
      padding: 14px 28px;
      border-radius: 12px;
      font-weight: 600;
      font-size: 15px;
      cursor: pointer;
      transition: all 0.3s;
    }
    
    .secondary-btn:hover {
      border-color: #E5332A;
      color: #E5332A;
      transform: translateY(-2px);
    }
    
    .secondary-btn:active {
      transform: translateY(0);
    }

    .empty-features {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      padding-top: 32px;
      border-top: 1px solid #e9ecef;
    }
    
    .feature-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding: 16px;
    }
    
    .feature-icon {
      width: 56px;
      height: 56px;
      background: linear-gradient(135deg, #fff5f5, #ffe8e8);
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #E5332A;
    }
    
    .feature-text {
      text-align: center;
    }
    
    .feature-text h4 {
      font-size: 14px;
      font-weight: 600;
      color: #2B2B2B;
      margin-bottom: 4px;
    }
    
    .feature-text p {
      font-size: 12px;
      color: #868e96;
      margin: 0;
    }
    
    .breadcrumb { 
      display: flex; 
      align-items: center; 
      gap: 8px; 
      margin-top: 20px; 
      margin-bottom: 20px; 
      font-size: 14px; 
      flex-wrap: wrap; 
    }
    
    .breadcrumb a { 
      color: #868e96; 
      transition: color 0.2s;
    }
    
    .breadcrumb a:hover { color: #E5332A; }
    
    .breadcrumb span:last-child { color: #2B2B2B; font-weight: 500; }
    
    .cart-layout {
      display: grid;
      grid-template-columns: 1fr 380px;
      gap: 32px;
      align-items: start;
    }
    
    .cart-items-section {
      background: #fff;
      border-radius: 20px;
      padding: 32px;
      margin-bottom: 32px;
    }
    
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      flex-wrap: wrap;
      gap: 12px;
    }
    
    .section-header h1 { font-size: 24px; }
    
    .clear-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      background: none;
      border: none;
      color: #868e96;
      font-size: 14px;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 8px;
      transition: all 0.2s;
    }
    
    .clear-btn:hover { 
      color: #E5332A; 
      background: #fff5f5;
    }
    
    .free-shipping-notice {
      display: flex;
      align-items: center;
      gap: 16px;
      background: #fff5f5;
      border: 1px solid #ffe0e0;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 24px;
    }
    
    .free-shipping-notice svg { color: #E5332A; flex-shrink: 0; }
    
    .notice-content { flex: 1; }
    
    .notice-content p { font-size: 14px; margin-bottom: 8px; }
    
    .progress-bar {
      height: 6px;
      background: #e9ecef;
      border-radius: 3px;
      overflow: hidden;
    }
    
    .progress-fill {
      height: 100%;
      background: linear-gradient(90deg, #E5332A, #ff4436);
      border-radius: 3px;
      transition: width 0.3s;
    }

    .free-shipping-achieved {
      display: flex;
      align-items: center;
      gap: 16px;
      background: linear-gradient(135deg, #dcfce7, #a7f3d0);
      border: 2px solid #22c55e;
      border-radius: 12px;
      padding: 16px;
      margin-bottom: 24px;
    }
    
    .free-shipping-achieved svg { 
      color: #16a34a; 
      flex-shrink: 0; 
    }
    
    .free-shipping-achieved .notice-content p {
      font-size: 14px;
      font-weight: 600;
      color: #16a34a;
      margin: 0;
    }

    .applied-offers-section {
      background: #f0fff4;
      border: 2px solid #dcfce7;
      border-radius: 16px;
      padding: 20px;
      margin-bottom: 24px;
    }
    
    .applied-offers-section > h3 {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      margin-bottom: 16px;
      color: #16a34a;
    }

    .near-miss-offers-section {
      background: #fffbeb;
      border: 2px solid #fef3c7;
      border-radius: 16px;
      padding: 20px;
      margin-bottom: 24px;
    }
    
    .near-miss-offers-section > h3 {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      margin-bottom: 16px;
      color: #f59e0b;
    }

    .applied-offer, .near-miss-offer {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      background: #fff;
      padding: 16px;
      border-radius: 12px;
      margin-bottom: 12px;
      border: 2px solid transparent;
    }
    
    .applied-offer:last-child, .near-miss-offer:last-child { margin-bottom: 0; }
    
    .applied-offer.campaign-applied { border-color: rgba(229, 51, 42, 0.2); }
    
    .near-miss-offer.campaign-near { border-color: rgba(245, 158, 11, 0.3); }

    .offer-icon {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    
    .offer-icon.campaign-icon {
      background: rgba(229, 51, 42, 0.1);
      color: #E5332A;
    }
    
    .offer-icon.campaign-icon-near {
      background: rgba(245, 158, 11, 0.1);
      color: #f59e0b;
    }

    .offer-info { flex: 1; min-width: 0; }
    
    .offer-title {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 6px;
      flex-wrap: wrap;
    }
    
    .offer-badge {
      display: inline-flex;
      align-items: center;
      padding: 4px 8px;
      border-radius: 6px;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }
    
    .offer-badge.campaign {
      background: rgba(229, 51, 42, 0.1);
      color: #E5332A;
    }
    
    .offer-name {
      font-weight: 600;
      font-size: 14px;
      color: #2B2B2B;
    }
    
    .offer-desc {
      font-size: 13px;
      color: #868e96;
      margin-bottom: 8px;
      line-height: 1.5;
    }
    
    .offer-discount {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: #dcfce7;
      color: #16a34a;
      padding: 4px 10px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 600;
    }

    .offer-warning {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: #fef3c7;
      color: #92400e;
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 12px;
      line-height: 1.5;
    }
    
    .offer-warning strong {
      color: #f59e0b;
    }
    
    .cart-items-list {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    
    .cart-item {
      display: flex;
      align-items: center;
      gap: 20px;
      padding: 20px;
      background: #f8f9fa;
      border-radius: 16px;
      transition: all 0.2s;
    }
    
    .cart-item:hover {
      box-shadow: 0 2px 12px rgba(0,0,0,0.06);
    }
    
    .item-image {
      width: 100px;
      height: 100px;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      flex-shrink: 0;
      background: #fff;
      display: block;
      transition: transform 0.2s;
    }
    
    .item-image:hover {
      transform: scale(1.05);
    }
    
    .item-image img { 
      width: 100%; 
      height: 100%; 
      object-fit: contain; 
    }
    
    .item-details { flex: 1; min-width: 0; }
    
    .item-details h3 {
      font-size: 16px;
      margin-bottom: 6px;
      cursor: pointer;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      transition: color 0.2s;
    }
    
    .item-details h3:hover { color: #E5332A; }
    
    .item-desc {
      font-size: 13px;
      color: #868e96;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin-bottom: 8px;
    }
    
    .discount-tag {
      display: inline-block;
      background: #E5332A;
      color: #fff;
      font-size: 11px;
      font-weight: 600;
      padding: 4px 8px;
      border-radius: 6px;
      margin-right: 8px;
    }

    .item-shipping-info {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 11px;
      color: #6c757d;
      background: #e9ecef;
      padding: 4px 8px;
      border-radius: 6px;
    }
    
    .item-shipping-info svg {
      flex-shrink: 0;
    }
    
    .item-actions {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
    }
    
    .quantity-controls {
      display: flex;
      align-items: center;
      border: 1px solid #e9ecef;
      border-radius: 10px;
      background: #fff;
    }
    
    .quantity-controls button {
      width: 40px;
      height: 40px;
      border: none;
      background: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
    }
    
    .quantity-controls button:hover:not(:disabled) {
      background: #f8f9fa;
    }
    
    .quantity-controls button:active:not(:disabled) {
      transform: scale(0.95);
    }
    
    .quantity-controls button:disabled { opacity: 0.4; cursor: not-allowed; }
    
    .quantity-controls span { width: 40px; text-align: center; font-weight: 600; }
    
    .item-price { text-align: right; min-width: 90px; }
    
    .original-price {
      display: block;
      font-size: 13px;
      color: #868e96;
      text-decoration: line-through;
    }
    
    .current-price { font-size: 18px; font-weight: 700; color: #E5332A; }
    
    .remove-btn {
      background: none;
      border: none;
      color: #868e96;
      cursor: pointer;
      padding: 8px;
      transition: all 0.2s;
      border-radius: 8px;
    }
    
    .remove-btn:hover { 
      color: #E5332A; 
      background: #fff5f5;
    }
    
    .order-summary {
      background: #fff;
      border-radius: 20px;
      padding: 32px;
      position: sticky;
      top: 20px;
      margin-bottom: 32px;
    }
    
    .order-summary h2 { font-size: 20px; margin-bottom: 24px; }
    
    .summary-details { margin-bottom: 24px; }
    
    .summary-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;
    }
    
    .summary-row span:first-child {
      display: flex;
      align-items: center;
      gap: 6px;
      color: #495057;
    }
    
    .summary-row span:last-child {
      font-weight: 600;
      color: #2B2B2B;
    }
    
    .summary-row.discount span { color: #06d6a0 !important; font-weight: 600; }
    
    .summary-row.discount.campaign svg { color: #E5332A; }
    
    .summary-row.shipping span:first-child { color: #495057; }
    
    .summary-row.shipping .free { color: #22c55e !important; font-weight: 700; }
    
    .summary-row.total-savings {
      background: #dcfce7;
      padding: 12px;
      border-radius: 10px;
      margin: 12px 0;
      font-weight: 600;
      color: #16a34a !important;
    }
    
    .summary-row.total-savings span {
      color: #16a34a !important;
    }
    
    .summary-row.total {
      font-size: 20px;
      font-weight: 700;
      padding-top: 16px;
      margin-top: 16px;
      border-top: 2px solid #e9ecef;
    }
    
    .summary-row.total span {
      color: #2B2B2B;
    }

    .savings-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      background: linear-gradient(135deg, #dcfce7, #a7f3d0);
      color: #16a34a;
      padding: 12px;
      border-radius: 12px;
      font-weight: 700;
      margin-bottom: 12px;
      animation: pulse 2s infinite;
    }

    .free-shipping-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      background: linear-gradient(135deg, #e0f2fe, #bae6fd);
      color: #0369a1;
      padding: 12px;
      border-radius: 12px;
      font-weight: 700;
      margin-bottom: 12px;
    }

    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.02); }
    }
    
    .checkout-btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      background: #E5332A;
      color: #fff;
      border: none;
      padding: 16px;
      border-radius: 14px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.2s;
    }
    
    .checkout-btn:hover { 
      background: #c72a22; 
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(229, 51, 42, 0.3);
    }
    
    .checkout-btn:active { transform: scale(0.98); }
    
    .security-info {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin-top: 16px;
      color: #868e96;
      font-size: 13px;
    }
    
    .payment-methods {
      margin-top: 24px;
      padding-top: 24px;
      border-top: 1px solid #e9ecef;
      text-align: center;
    }
    
    .payment-methods p { font-size: 13px; color: #868e96; margin-bottom: 12px; }
    
    .methods { display: flex; justify-content: center; gap: 16px; font-size: 13px; flex-wrap: wrap; }

    .no-free-shipping-info {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff9e6;
  border: 1px solid #ffe8a1;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.no-free-shipping-info svg { 
  color: #f59e0b; 
  flex-shrink: 0; 
}

.no-free-shipping-info .notice-content p {
  font-size: 14px;
  color: #92400e;
  margin: 0;
}

    /* Responsive Styles */
    @media (max-width: 992px) {
      .cart-layout {
        grid-template-columns: 1fr;
      }
      
      .order-summary {
        position: static;
      }
      
      .empty-features {
        grid-template-columns: 1fr;
        gap: 16px;
      }
    }

    @media (max-width: 768px) {
      .container { padding: 0 16px; }
      
      .breadcrumb { 
        margin-top: 16px; 
        margin-bottom: 16px;
        font-size: 13px;
      }
      
      .cart-items-section { 
        padding: 20px 16px; 
        border-radius: 16px; 
        margin-bottom: 20px;
      }
      
      .section-header { gap: 8px; }
      
      .section-header h1 { font-size: 20px; }
      
      .clear-btn span { display: none; }
      
      .free-shipping-notice { 
        padding: 12px; 
        gap: 12px;
      }
      
      .free-shipping-notice svg { 
        width: 18px; 
        height: 18px; 
      }
      
      .notice-content p { font-size: 13px; }
      
      .free-shipping-achieved { 
        padding: 12px; 
        gap: 12px;
      }
      
      .applied-offers-section, 
      .near-miss-offers-section {
        padding: 16px;
      }
      
      .applied-offers-section > h3,
      .near-miss-offers-section > h3 {
        font-size: 14px;
      }
      
      .applied-offer, .near-miss-offer {
        padding: 12px;
        gap: 10px;
      }
      
      .offer-icon {
        width: 36px;
        height: 36px;
      }
      
      .offer-icon svg {
        width: 16px;
        height: 16px;
      }
      
      .offer-name { font-size: 13px; }
      
      .offer-desc { font-size: 12px; }
      
      .cart-item { 
        flex-direction: column; 
        align-items: stretch; 
        padding: 16px; 
        gap: 12px; 
      }
      
      .item-image { 
        width: 100%; 
        height: 200px; 
        align-self: center;
        max-width: 200px;
      }
      
      .item-details h3 { font-size: 15px; }
      
      .item-desc { font-size: 12px; }
      
      .item-actions { 
        justify-content: space-between; 
        padding-top: 12px; 
        border-top: 1px solid #e9ecef;
        flex-wrap: wrap;
        gap: 12px;
      }
      
      .quantity-controls {
        order: 1;
      }
      
      .item-price {
        order: 2;
        min-width: auto;
      }
      
      .remove-btn {
        order: 3;
      }
      
      .continue-shopping-link {
        display: block;
      }
      
      .continue-shopping {
        width: 100%;
        justify-content: center;
        font-size: 14px;
      }
      
      .order-summary { 
        padding: 20px 16px; 
        border-radius: 16px; 
        margin-top: 0;
      }
      
      .order-summary h2 { font-size: 18px; }
      
      .summary-row { font-size: 13px; }
      
      .summary-row.total { font-size: 18px; }
      
      .checkout-btn { font-size: 15px; padding: 14px; }
      
      .empty-cart-section {
        min-height: 400px;
        padding: 40px 16px;
      }
      
      .empty-cart-content {
        padding: 40px 24px;
        border-radius: 20px;
      }
      
      .empty-icon-wrapper {
        width: 100px;
        height: 100px;
      }
      
      .empty-icon-bg {
        width: 100px;
        height: 100px;
      }
      
      .empty-icon-wrapper svg {
        width: 56px;
        height: 56px;
        margin-top: 22px;
      }
      
      .empty-cart-content h1 {
        font-size: 24px;
      }
      
      .empty-cart-content > p {
        font-size: 14px;
      }
      
      .empty-actions {
        flex-direction: column;
        width: 100%;
      }
      
      .primary-btn-link,
      .secondary-btn-link {
        width: 100%;
      }
      
      .primary-btn, .secondary-btn {
        width: 100%;
        justify-content: center;
        font-size: 14px;
        padding: 12px 24px;
      }
      
      .empty-features {
        grid-template-columns: 1fr;
        gap: 12px;
      }
      
      .feature-item {
        flex-direction: row;
        justify-content: flex-start;
        text-align: left;
        padding: 12px;
      }
      
      .feature-icon {
        width: 48px;
        height: 48px;
      }
      
      .feature-text {
        text-align: left;
      }
      
      .feature-text h4 {
        font-size: 13px;
      }
      
      .feature-text p {
        font-size: 11px;
      }

      .no-free-shipping-info { 
    padding: 12px; 
    gap: 12px;
  }
  
  .no-free-shipping-info svg { 
    width: 18px; 
    height: 18px; 
  }
  
  .no-free-shipping-info .notice-content p { 
    font-size: 13px; 
  }
    }
    
    @media (max-width: 576px) {
      .cart-item {
        padding: 12px;
      }
      
      .item-image {
        height: 160px;
      }
      
      .quantity-controls button {
        width: 36px;
        height: 36px;
      }
      
      .quantity-controls span {
        width: 36px;
      }
      
      .current-price { font-size: 16px; }
      
      .empty-icon-wrapper {
        width: 80px;
        height: 80px;
      }
      
      .empty-icon-bg {
        width: 80px;
        height: 80px;
      }
      
      .empty-icon-wrapper svg {
        width: 48px;
        height: 48px;
        margin-top: 16px;
      }
      
      .empty-cart-content h1 {
        font-size: 22px;
      }
    }
  `}</style>;
}